import operationTypes from 'constants/operationTypes';

export const operationsPartnerTransactions = [
  operationTypes.CONSTITUTION,
  operationTypes.CAPITAL_DECREASE,
  operationTypes.CAPITAL_INCREASE,
  operationTypes.SELL_PARTICIPATION,
  operationTypes.HERITAGE,
  operationTypes.DONATION,
  operationTypes.ENDORSEMENT,
  operationTypes.TRANSMISSION,
  operationTypes.DIVIDENDS_DISTRIBUTION,
  operationTypes.SPLIT,
  operationTypes.RENUMERATION,
  operationTypes.ENDORSEMENT,
  operationTypes.RECLASSIFICATION,
];
